import {  FundOutlined, PieChartFilled, PieChartOutlined } from "@ant-design/icons";
import { Button, Card, Menu, Modal, Row, Space } from "antd";
import React, { useEffect, useState } from "react";
import { Responsive, WidthProvider } from "react-grid-layout";

import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { useLoaderData } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { addKpiToDashboard, getMyKpis, removeKpiFromDashboard, updateDashboardLayout } from "./dashboardThunk";
import KPIDisplay from "../../app/components/kpiDisplay";
import { time } from "console";

const ResponsiveReactGridLayout = WidthProvider(Responsive);

// const layout = [
//     { i: "a", x: 0, y: 0, w: 4, h: 2 },
//     { i: "b", x: 4, y: 0, w: 4, h: 2 },
//     { i: "c", x: 8, y: 0, w: 4, h: 2 },
// ];

const Dashboard: React.FC = () => {
    const dispatch = useAppDispatch();
    const [showWidgetModal, setShowWidgetModal] = useState(false);

    const allKpis:any = useLoaderData();

    const myKpis = useAppSelector((state) => state.dashboard.myKpis);
    const layouts = useAppSelector((state) => state.dashboard.layout);

    useEffect(() => {
        dispatch(getMyKpis());
    }, []);
    

    function handleMenuSelect(e: any) {
        console.log('Selected KPI:', e);
        dispatch(addKpiToDashboard({kpiId:e.key}));
        setShowWidgetModal(false);
    }

    return (
        <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Row justify="end" align="middle" style={{ marginBottom: 16 }}>
                <Space direction="horizontal" size="large">
                    <Button 
                        type="primary" 
                        icon={<PieChartFilled />}
                        onClick={() => setShowWidgetModal(true)}
                    >
                        Add Widget
                    </Button>
                </Space>
            </Row>
            <div style={{ flexGrow: 1, minHeight: 100 }}>
                <ResponsiveReactGridLayout
                    className="layout"
                    layouts={layouts}
                    isDraggable={false}
                    isResizable={false}
                    breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
                    cols={{ lg: 3, md: 3, sm: 2, xs: 1, xxs: 1 }}
                    // onLayoutChange={(layout: any, layouts: any) => {
                    //     dispatch(updateDashboardLayout({ layout: layouts }));
                    // }}
                >
                    {
                        myKpis.map((kpi: any) => {
                            return <div key={kpi._id} style={{ margin: 8 }}>
                                <KPIDisplay
                                    title={kpi.title}
                                    kpiResponse={kpi}
                                    onDelete={() => {
                                        dispatch(removeKpiFromDashboard(kpi._id));
                                    }}
                                />
                            </div>
                        })
                    }


                </ResponsiveReactGridLayout>
            </div>
            <Modal
                title="Add Widget"
                open={showWidgetModal}
                footer={null}
                onCancel={() => setShowWidgetModal(false)}
            >
                <Menu
                    mode="inline"
                    onClick={handleMenuSelect}
                >
                    {allKpis.map((kpiGroup: any) => (
                        <Menu.SubMenu
                            key={kpiGroup._id}
                            title={kpiGroup.title}
                        >
                            {kpiGroup.kpis.map((kpi: any) => (
                                <Menu.Item key={kpi._id}>
                                    {kpi.title}
                                </Menu.Item>
                            ))}
                        </Menu.SubMenu>
                    ))}
                </Menu>
            </Modal>
        </div>
    );
};

export default Dashboard;